<div class="title-section">
  <h3>{{ getMenuLabelStartingFromCaptive() }}</h3>
  <mat-icon (click)="close()" class="pointer">close</mat-icon>
</div>
<mat-nav-list class="nav-list">
  <div *ngIf="sideNavItems != undefined && sideNavItems.length > 0">
    <mat-accordion class="menu-accordion">
      <div *ngFor="let menu of sideNavItems">
        <mat-expansion-panel
          *ngIf="menu.child?.length > 0"
          #recursiveListTmpl
          class="menu-panel"
        >
          <mat-expansion-panel-header class="menu-panel-title">
            {{ menu.label | i18n }}
          </mat-expansion-panel-header>
          <mat-nav-list *ngFor="let child of menu.child">
            <a
              mat-list-item
              routerLinkActive="active"
              *ngIf="child.child?.length === 0"
              (click)="navigateAndCloseSideNav(child)"
              myAldEvent="menu" [myAldEventLabel]="menu.label + '_' + child.label"
              >{{ child.label | i18n }}</a
            >
            <div *ngIf="child.child?.length > 0">
              <ng-container
                [ngTemplateOutlet]="subMenu"
                [ngTemplateOutletContext]="{ $implicit: child }"
              >
              </ng-container>
            </div>
          </mat-nav-list>
        </mat-expansion-panel>
        <div *ngIf="menu.child?.length === 0">
          <a
            mat-list-item
            routerLinkActive="active"
            (click)="navigateAndCloseSideNav(menu)"
            myAldEvent="menu" [myAldEventLabel]="menu.label"
            class="radius menu-item"
            >{{ menu.label | i18n }}</a
          >
        </div>
      </div>
    </mat-accordion>
  </div>
</mat-nav-list>

<ng-template #subMenuItem let-menuItems>
  <a
    mat-list-item
    routerLinkActive="active"
    (click)="navigateAndCloseSideNav(menu)"
    *ngFor="let menu of menuItems"
    >{{ menu.label | i18n }}</a
  >
</ng-template>

<ng-template #subMenu let-child>
  <mat-expansion-panel [class.mat-elevation-z0]="true">
    <mat-expansion-panel-header>
      {{ child.label | i18n }}
    </mat-expansion-panel-header>

    <mat-nav-list *ngFor="let child of child.child">
      <a
        mat-list-item
        routerLinkActive="active"
        (click)="navigateAndCloseSideNav(child)"
   
        *ngIf="child.child?.length === 0"
        >{{ child.label | i18n }}</a
      >
      <div *ngIf="child.child?.length > 0">
        <ng-container
          [ngTemplateOutlet]="subMenu"
          [ngTemplateOutletContext]="{ $implicit: child }"
        >
        </ng-container>
      </div>
    </mat-nav-list>
  </mat-expansion-panel>
</ng-template>
